/**
 * Props that wire a form field to its error message for assistive tech.
 *
 * react-hook-form's `{...register()}` sets neither `aria-invalid` nor
 * `aria-describedby`, so a screen-reader user who submits an invalid field
 * hears nothing when they return to it — the error `<p>` is painted but not
 * associated. Spread the result onto the input and give the matching error
 * `<p>` the same `errorId`:
 *
 *   <Input {...register('email')} {...fieldAria(!!errors.email, 'email-error')} />
 *   {errors.email && <p id="email-error" className="text-bad">{errors.email.message}</p>}
 *
 * `aria-invalid` is omitted (not `"false"`) when valid so the destructive
 * styling and the invalid state only apply when there's actually an error.
 */
export function fieldAria(hasError: boolean, errorId: string): {
  'aria-invalid': true | undefined;
  'aria-describedby': string | undefined;
} {
  return {
    'aria-invalid': hasError || undefined,
    'aria-describedby': hasError ? errorId : undefined,
  };
}
